import styled, {
  css,
  Palette,
  PaletteVariants,
  RoundedCornerSizes,
  Sizes,
  WidthSizes,
} from 'styled-components';
import { MarginProps, styledMargin } from '../Margins/margins';

export type BoxProps = {
  bg?: Palette;
  bgShade?: PaletteVariants;
  radius?: RoundedCornerSizes;
  maxWidth?: WidthSizes;
  textAlign?: 'center';
  fullWidth?: boolean;
  display?: 'flex';
  /* useful to set when only wrapping grahpics like an image */
  lineHeight?: number;
  relative?: boolean;
} & MarginProps &
  PaddingProps;

export type PaddingProps = {
  px?: Sizes;
  py?: Sizes;
  pb?: Sizes;
  pt?: Sizes;
  pl?: Sizes | 'auto';
  pr?: Sizes | 'auto';
};

export const styledPadding = css<PaddingProps>`
  ${(props) =>
    props.px &&
    css`
      padding-left: ${props.theme.sizes[props.px]};
      padding-right: ${props.theme.sizes[props.px]};
    `}
  ${(props) =>
    props.py &&
    css`
      padding-top: ${props.theme.sizes[props.py]};
      padding-bottom: ${props.theme.sizes[props.py]};
    `}
  ${(props) =>
    props.pt &&
    css`
      padding-top: ${props.theme.sizes[props.pt]};
    `}
  ${(props) =>
    props.pr &&
    css`
      padding-right: ${props.theme.sizes[props.pr]};
    `}
  ${(props) =>
    props.pb &&
    css`
      padding-bottom: ${props.theme.sizes[props.pb]};
    `}
  ${(props) =>
    props.pl &&
    css`
      padding-left: ${props.theme.sizes[props.pl]};
    `}
`;

export const Box = styled.div<BoxProps>`
  ${styledMargin}
  ${styledPadding}
  ${({ bg, bgShade, theme }) =>
    bg &&
    `
      background-color: ${theme.palette[bg][bgShade || 'main']};
    `}
  ${({ radius, theme }) =>
    radius &&
    `
      border-radius: ${theme.roundedCorners[radius]};
    `}
  ${({ maxWidth, theme }) =>
    maxWidth &&
    `
      max-width: ${theme.widths[maxWidth]};
    `}
  ${({ textAlign }) =>
    textAlign &&
    `
      text-align: center;
    `}
  ${({ fullWidth }) =>
    fullWidth &&
    `
      width: 100%;
    `}
  ${({ lineHeight }) =>
    lineHeight &&
    `
      line-height: ${lineHeight};
    `}
  ${({ display }) =>
    display &&
    `
      display: ${display};
    `}
  ${({ relative }) =>
    relative &&
    `
      position: relative;
    `}
`;
